import React from 'react';
import CartModalItemFields from './CartModalItemFields';
import css from './CartModalItem.module.css';

const CartModalItem = props => {
    const {
        item,
        intl,
        form,
        formValues,
        onRemoveFromCart,
        fetchLineItemsInProgress,
        currentUserCurrency,
        exchangeRates,
    } = props;

    return (
        <div className={css.itemContainer}>
            <CartModalItemFields
                item={item}
                intl={intl}
                form={form}
                formValues={formValues}
                onRemoveFromCart={onRemoveFromCart}
                fetchLineItemsInProgress={fetchLineItemsInProgress}
                currentUserCurrency={currentUserCurrency}
                exchangeRates={exchangeRates}
            />
        </div>
    );
};

export default CartModalItem;
